import { Injectable, Type } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SharedModalComponent } from './shared-modal.component';

@Injectable({
  providedIn: 'root',
})
export class SharedModalService {
  private isModalOpen = false;
  constructor(private modalService: NgbModal) {}

  open<T>(component: Type<T>, data?: any, options?: NgbModalOptions) {
    if (this.isModalOpen) return; 
    this.isModalOpen = true;
    const modalRef = this.modalService.open(SharedModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      ...options, 
    });

    
    modalRef.componentInstance.contentComponent = component;
    modalRef.componentInstance.data = data;
    
    modalRef.result.finally(() => {
      this.isModalOpen = false;
    });

    return modalRef.result; 
  }
}
